import type { GameProfile } from '../types';

const WHITE = '#f4f4f4';

export const sicbo: GameProfile = {
  id: 'sicbo',
  label: 'Sicbo (3 machines × 6 balls)',
  ballIds: [1, 2, 3, 4, 5, 6],
  colorFor: () => WHITE,
  textureStyle: 'sicbo',
  machineCount: 3,
  resultsPerDraw: 3,
};
